import { defineHotpadsEvent, trackHotpadsEventDefinition } from '../track';
import type { ListingArg } from './types';

const LEGACY_SOURCE = 'srcLegacy/shared/models/Clickstream/PageViewEvents.ts';

const VIEW_HDP = defineHotpadsEvent({
  key: 'page_view.hdp',
  eventTypeId: '4785',
  eventTypeVersionId: '2',
  eventTemplateId: '285',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackViewHdpEvent',
  trigger: {
    type: 'view',
    location: 'home_details',
    source: 'home_details',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const AGENTIC_VIEW_HDP = defineHotpadsEvent({
  key: 'page_view.agentic_hdp',
  eventTypeId: '8470',
  eventTypeVersionId: '3',
  eventTemplateId: '381',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackAgenticViewHdpEvent',
  trigger: {
    type: 'view',
    location: 'home_details',
    source: 'home_details',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const VIEW_HOMEPAGE = defineHotpadsEvent({
  key: 'page_view.homepage',
  eventTypeId: '5719',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackViewHomepageEvent',
  trigger: {
    type: 'view',
    location: 'hp_homepage',
    source: 'hp_homepage',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const VIEW_MY_HUB = defineHotpadsEvent({
  key: 'page_view.my_hub',
  eventTypeId: '6207',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackViewMyHubEvent',
  trigger: {
    type: 'view',
    location: 'my_hub_page',
    source: 'my_hub_page',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const VIEW_SEARCH_ALERTS = defineHotpadsEvent({
  key: 'page_view.search_alerts',
  eventTypeId: '6208',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackViewSearchAlertsPageEvent',
  trigger: {
    type: 'view',
    location: 'search_alerts_page',
    source: 'search_alerts_page',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const VIEW_LOGIN = defineHotpadsEvent({
  key: 'page_view.login',
  eventTypeId: '6209',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackViewLoginPageEvent',
  trigger: {
    type: 'view',
    location: 'login_screen',
    source: 'login_screen',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const VIEW_USER_ACCOUNT = defineHotpadsEvent({
  key: 'page_view.user_account',
  eventTypeId: '6210',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackViewUserAccountPageEvent',
  trigger: {
    type: 'view',
    location: 'user_account_page',
    source: 'user_account_page',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const VIEW_MY_LIST = defineHotpadsEvent({
  key: 'page_view.my_list',
  eventTypeId: '6211',
  eventTypeVersionId: '2',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackViewMyListPageEvent',
  trigger: {
    type: 'view',
    location: 'user_item_list_page',
    source: 'user_item_list_page',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const VIEW_VIEWED_LISTINGS = defineHotpadsEvent({
  key: 'page_view.viewed_listings',
  eventTypeId: '6212',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackViewViewedListingsPageEvent',
  trigger: {
    type: 'view',
    location: 'user_item_viewed_page',
    source: 'user_item_viewed_page',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const VIEW_HIDDEN_LISTINGS = defineHotpadsEvent({
  key: 'page_view.hidden_listings',
  eventTypeId: '6213',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackViewHiddenListingsPageEvent',
  trigger: {
    type: 'view',
    location: 'user_item_viewed_page',
    source: 'user_item_viewed_page',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const VIEW_SETTINGS = defineHotpadsEvent({
  key: 'page_view.settings',
  eventTypeId: '6214',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackViewSettingsPageEvent',
  trigger: {
    type: 'view',
    location: 'edit_settings_page',
    source: 'edit_settings_page',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const VIEW_SRP = defineHotpadsEvent({
  key: 'page_view.srp',
  eventTypeId: '5720',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackViewSrpEvent',
  trigger: {
    type: 'view',
    location: 'search_results',
    source: 'search_results',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

const AGENTIC_VIEW_SRP = defineHotpadsEvent({
  key: 'page_view.agentic_srp',
  eventTypeId: '8470',
  eventTypeVersionId: '3',
  eventTemplateId: '381',
  eventTemplateVersionId: '1',
  legacySource: LEGACY_SOURCE,
  legacyExport: 'emitTrackAgenticViewSrpEvent',
  trigger: {
    type: 'view',
    location: 'search_results',
    source: 'search_results',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

// Net-new events (no hotpads-web twin) — https://dataportal.zillowgroup.net/event-registry/10175
const VIEW_STATE_PAGE = defineHotpadsEvent({
  key: 'page_view.state_page',
  eventTypeId: '10175',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  trigger: {
    type: 'view',
    location: 'hp_state_page',
    source: 'hp_state_page',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

// https://dataportal.zillowgroup.net/event-registry/10176
const VIEW_CITY_PAGE = defineHotpadsEvent({
  key: 'page_view.city_page',
  eventTypeId: '10176',
  eventTypeVersionId: '1',
  eventTemplateId: '171',
  eventTemplateVersionId: '1',
  trigger: {
    type: 'view',
    location: 'hp_city_page',
    source: 'hp_city_page',
    object: 'no_trigger_object',
  },
  semanticEvent: 'view_content',
});

type SettingsPageTriggers = 'edit_profile_page' | 'renter_profile' | 'edit_settings_page';

export function emitTrackViewHdpEvent({
  listing,
  triggerLocation = 'home_details',
  isAgentic = false,
}: ListingArg & { triggerLocation?: string; isAgentic?: boolean } = {}) {
  if (isAgentic) {
    emitTrackAgenticViewHdpEvent();
    return;
  }

  trackHotpadsEventDefinition(VIEW_HDP, { listing, triggerLocation });
}

export function emitTrackAgenticViewHdpEvent() {
  trackHotpadsEventDefinition(AGENTIC_VIEW_HDP);
}

export function emitTrackViewHomepageEvent() {
  trackHotpadsEventDefinition(VIEW_HOMEPAGE);
}

export function emitTrackViewMyHubEvent() {
  trackHotpadsEventDefinition(VIEW_MY_HUB);
}

export function emitTrackViewSearchAlertsPageEvent() {
  trackHotpadsEventDefinition(VIEW_SEARCH_ALERTS);
}

export function emitTrackViewLoginPageEvent() {
  trackHotpadsEventDefinition(VIEW_LOGIN);
}

export function emitTrackViewUserAccountPageEvent() {
  trackHotpadsEventDefinition(VIEW_USER_ACCOUNT);
}

export function emitTrackViewMyListPageEvent() {
  trackHotpadsEventDefinition(VIEW_MY_LIST);
}

export function emitTrackViewViewedListingsPageEvent() {
  trackHotpadsEventDefinition(VIEW_VIEWED_LISTINGS);
}

export function emitTrackViewHiddenListingsPageEvent() {
  trackHotpadsEventDefinition(VIEW_HIDDEN_LISTINGS);
}

export function emitTrackViewSettingsPageEvent({
  triggerLocation,
  triggerSource,
}: {
  triggerLocation: SettingsPageTriggers;
  triggerSource: SettingsPageTriggers;
}) {
  trackHotpadsEventDefinition(VIEW_SETTINGS, { triggerLocation, triggerSource });
}

export function emitTrackViewStatePageEvent() {
  trackHotpadsEventDefinition(VIEW_STATE_PAGE);
}

export function emitTrackViewCityPageEvent() {
  trackHotpadsEventDefinition(VIEW_CITY_PAGE);
}

export function emitTrackViewSrpEvent({ isAgentic = false }: { isAgentic?: boolean } = {}) {
  if (isAgentic) {
    emitTrackAgenticViewSrpEvent();
    return;
  }

  trackHotpadsEventDefinition(VIEW_SRP);
}

export function emitTrackAgenticViewSrpEvent() {
  trackHotpadsEventDefinition(AGENTIC_VIEW_SRP);
}
